import LightClientApi from '@openclassrooms/sdk';
import type { ClientApi } from '@openclassrooms/sdk-web';
import type OCAISDK from '@openclassrooms/js-ai-sdk';
import type { AIServerName } from '../../utils/interfaces';

export default (() => {
  let aiClientFactory: ((serverName: AIServerName) => OCAISDK) | null = null;
  let ocClient: ClientApi | null = null;
  let lightOcClient: LightClientApi<APIEndpoints> | null = null;
  const aiClients = new Map<AIServerName, OCAISDK>();

  return {
    setOCClient(newClient: ClientApi) {
      ocClient = newClient;
    },
    getOCClient(): ClientApi {
      // istanbul ignore next
      if (!ocClient) {
        throw new ReferenceError(
          '[data-connect-web] calling getOCClient() but no client has been set: did you forget to call setOCClient()?'
        );
      }

      return ocClient;
    },

    setLightOCClient(newClient: LightClientApi<APIEndpoints>) {
      lightOcClient = newClient;
    },
    getLightOCClient(): LightClientApi<APIEndpoints> {
      // istanbul ignore next
      if (!lightOcClient) {
        throw new ReferenceError(
          '[data-connect-web] calling getLightOCClient() but no client has been set: did you forget to call setLightOCClient()?'
        );
      }

      return lightOcClient;
    },

    getAIClient(/* istanbul ignore next */ serverName: AIServerName = 'ai-api-student'): OCAISDK {
      // istanbul ignore next
      if (!aiClientFactory) {
        throw new ReferenceError(
          '[data-connect-web] calling getAIClient() but no factory has been set: did you forget to call setAIClientFactory()?'
        );
      }

      if (aiClients.has(serverName)) {
        return aiClients.get(serverName)!;
      }

      const client = aiClientFactory(serverName);
      aiClients.set(serverName, client);

      return client;
    },

    setAIClientFactory(factory: (serverName: AIServerName) => OCAISDK) {
      aiClientFactory = factory;
      aiClients.clear();
    },
  };
})();
